(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/widgets-campaign/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/widgets-campaign/assets/javascripts/init.js');
"use strict";

const {
  Fragment
} = React;
const {
  WidgetArea
} = svs.components.tb_ui_react.widget_area;
const {
  Background
} = svs.widgetsCampaign.components;
const availableFrames = {
  jul2023: svs.widgetsCampaign.frames.christmas2023.Christmas,
  valentines2024: svs.widgetsCampaign.frames.valentines2024.Valentines,
  valentinesSplit2024: svs.widgetsCampaign.frames.valentinesSplit2024.Valentines,
  easter2024: svs.widgetsCampaign.frames.easter2024.Easter,
  mothersDay2024: svs.widgetsCampaign.frames.mothersDay2024.MothersDay
};
const chosenFrame = svs.widgetsCampaign.data.moduleConfig.frame;
const customBg = svs.widgetsCampaign.data.moduleConfig.customBg;
const Frame = availableFrames[chosenFrame] || Fragment;
const frameCoverage = svs.widgetsCampaign.data.moduleConfig.frameCoverage;
const showTop = [undefined, '', 'full', 'top'].includes(frameCoverage);
const showBottom = [undefined, '', 'full', 'bottom'].includes(frameCoverage);
svs.widgetsCampaign.init = () => {
  Frame && ReactDOM.render( React.createElement(Fragment, null, React.createElement(Background, {
    image: customBg
  }), React.createElement(Frame, {
    showBottom: showBottom,
    showTop: showTop
  }, React.createElement(WidgetArea, {
    areaName: "moduleMain",
    className: "relative widget-area-campaign"
  }))), document.getElementById('reactContainer'));
};
svs.widgetsCampaign.init();

 })(window);